import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useSettings } from '../context/SettingsContext';
import QuoteForm from '../components/QuoteForm';

function Quote() {
  const { settings } = useSettings();

  const title = settings.quote_title || 'Projeniz İçin Teklif Alın';
  const description = settings.quote_description || 'Tadilat ve dekorasyon projeleriniz icin ucretsiz kesif ve fiyat teklifi almak icin formu doldurun.';
  const features = settings.quote_features
    ? settings.quote_features.split(',').map(f => f.trim()).filter(Boolean)
    : ['Ücretsiz Keşif', 'Hızlı Geri Dönüş', 'Detaylı Fiyatlandırma', 'Profesyonel Danışmanlık'];

  return (
    <>
      <Helmet>
        <title>Ücretsiz Teklif Al | {settings.site_title || ''}</title>
        <meta name="description" content={description} />
      </Helmet>

      <div className="page-header">
        <div className="container">
          <h1>Ücretsiz Teklif Al</h1>
          <div className="breadcrumb">
            <Link to="/">Ana Sayfa</Link>
            <span>/</span>
            <span>Teklif Al</span>
          </div>
        </div>
      </div>

      <section className="section">
        <div className="container">
          <div className="quote-page-wrapper">
            <div className="quote-page-info">
              <h2>{title}</h2>
              <p>{description}</p>
              {features.length > 0 && (
                <div className="quote-page-features">
                  {features.map((feature, i) => (
                    <div className="quote-feature" key={i}>
                      <span className="quote-feature-icon">✓</span>
                      <span>{feature}</span>
                    </div>
                  ))}
                </div>
              )}
              {settings.phone && (
                <div className="quote-page-phone">
                  <span>Hemen Arayin:</span>
                  <a href={`tel:${settings.phone}`}>{settings.phone}</a>
                </div>
              )}
            </div>
            <div className="quote-page-form">
              <QuoteForm />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Quote;
